import React from 'react';
import { Route, Switch } from 'react-router';
import AssessmentReviewDetailBreakouts from './AssessmentReviewDetailBreakouts';
import Breakout from './Breakout';

export default function AssessmentReviewBreakoutRoutes({
  path,
  assessment,
  onSave,
  saving,
  categoryColorMap,
  listPath,
  computedMatch,
  location,
}) {
  return (
    <Route path={path} computedMatch={computedMatch} location={location}>
      <Switch>
        <Route
          path={`${path}/new`}
          render={() => (
            <Breakout
              assessment={assessment}
              categoryColorMap={categoryColorMap}
              onSave={onSave}
              saving={saving}
              listPath={listPath}
            />
          )}
        />
        <Route
          path={`${path}/:breakoutName`}
          render={() => (
            <Breakout
              assessment={assessment}
              categoryColorMap={categoryColorMap}
              onSave={onSave}
              saving={saving}
              listPath={listPath}
            />
          )}
        />
        <Route
          exact
          path={path}
          render={() => (
            <AssessmentReviewDetailBreakouts
              assessment={assessment}
              onSave={onSave}
              saving={saving}
              basePath={listPath}
            />
          )}
        />
      </Switch>
    </Route>
  );
}
